var $ = require('jquery');
var jQuery = require('jquery');

// Object.size = function(obj) {
//     var size = 0, key;
//     for (key in obj) {
//         if (obj.hasOwnProperty(key)) size++;
//     }
//     return size;
// };

window.ksort = obj => {
  var keys = Object.keys(obj).sort()
    , sortedObj = {};

  for(var i in keys) {
    sortedObj[keys[i]] = obj[keys[i]];
  }

  return sortedObj;
}

window.hexToRgbA = (hex, opacity) => {
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+', ' + opacity + ')';
    }
    throw new Error('Bad Hex');
}

window.decodeHTMLEntities = (str) => {
    
    let $tmp = $('<div>');      
    
    if (str && typeof str === 'string') {
        // strip script/html tags
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
        
        $tmp[0].innerHTML = str;
        str = $tmp[0].textContent;
        $tmp[0].textContent = '';
    }

    return str;
}

// function removeQuotes(string) {
//     if (typeof string === 'string' || string instanceof String) {
//         string = string.replace(/^['"]+|\s+|\\|(;\s?})+|['"]$/g, '');
//     }
//     return string;
// }

// function isChildOf(child, parent) {
//     if (child.parentNode === parent) {
//         return true;
//     } else if (child.parentNode === null) {
//         return false;
//     } else {
//         return isChildOf(child.parentNode, parent);
//     }
// }


// Array.prototype.move = function(from,to){
//   this.splice(to,0,this.splice(from,1)[0]);
//   return this;
// };

// var clientDevice = {

//   viewport: $(window).width(),

//   get touch(){

//       if( 'ontouchstart' in window || navigator.maxTouchPoints ){
//           $('html').removeClass('no-touch')
//           return true
//       }

//       return false
//   },

//   // mobile
//   get mobile(){

//     if(this.viewport < 768){
//       return true
//     }

//   },

//   // tablet
//   get tablet(){

//     if(this.viewport < 1024){
//       return true
//     }

//   },

//   // desktop
//   get desktop(){

//     if(this.viewport < 1200){
//       return true
//     }

//   },

//   // large desktop
//   get large_desktop(){

//     if(this.viewport >= 1200){
//       return true
//     }

//   },

//   refresh: function(){
//     this.viewport = $(window).width()
//   }

// }


(function($,sr){

  // debouncing function from John Hann
  // http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
  var debounce = function (func, threshold, execAsap) {
      var timeout;

      return function debounced () {
          var obj = this, args = arguments;
          function delayed () {
              if (!execAsap)
                  func.apply(obj, args);
              timeout = null;
          };

          if (timeout)
              clearTimeout(timeout);
          else if (execAsap)
              func.apply(obj, args);

          timeout = setTimeout(delayed, threshold || 100);
      };
  }
  // smartresize 
  jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

})(jQuery,'smartresize');

// $.fn.customerPopup = function (e, intWidth, intHeight, blnResize) {
    
//     // Prevent default anchor event
//     //e.preventDefault();

//     // Set values for window
//     intWidth = intWidth || '500';
//     intHeight = intHeight || '400';
//     strResize = (blnResize ? 'yes' : 'no');

//     // Set title and open popup with focus on it
//     var strTitle = ((typeof this.attr('title') !== 'undefined') ? this.attr('title') : 'Social Share'),
//         strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,            
//         objWindow = window.open(this.attr('href'), strTitle, strParam).focus();
//     return false;
// };

// window.checkIOSVersion = function () {
//     var agent = window.navigator.userAgent,
//     start = agent.indexOf( 'OS ' );
//     if( ( agent.indexOf( 'iPhone' ) > -1 || agent.indexOf( 'iPad' ) > -1 ) && start > -1 ){
//         return window.Number( agent.substr( start + 3, 3 ).replace( '_', '.' ) );
//     }
//     return 0;
// }
// window.is_touch_device = () => {
//   return 'ontouchstart' in window        // works on most browsers 
//       || 'onmsgesturechange' in window;  // works on IE10 with some false positives
// };
// window.is_android = () => /(android)/i.test(navigator.userAgent);
// window.iOS = () => /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
// window.isFirefox = () => navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

window.validateEmail = function(email){
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

const imagesLoaded = require('imagesloaded');

// Map number x from range [a, b] to [c, d]
const map = (x, a, b, c, d) => (x - a) * (d - c) / (b - a) + c;

// Linear interpolation
const lerp = (a, b, n) => (1 - n) * a + n * b;

const clamp = (num, min, max) => num <= min ? min : num >= max ? max : num;

const randomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

// Gets the mouse position
const getMousePos = e => {
    return { 
        x : e.clientX, 
        y : e.clientY 
    };
};

// Preload images
const preloadImages = (selector = 'img') => {
    return new Promise((resolve) => {
        imagesLoaded(document.querySelectorAll(selector), {background: true}, resolve);
    });
};

// Preload images
const preloadFonts = (id) => {
    return new Promise((resolve) => {
        WebFont.load({
            typekit: {
                id: id
            },
            active: resolve
        });
    });
};

window.hideOnClickOutside = (element, callback) => {
    
    const outsideClickListener = event => {

        if ($(event.target).is('img')) return

        if (!element.contains(event.target) && isVisible(element)) { // or use: event.target.closest(selector) === null
          // element.style.display = 'none'
          callback.call(callback)
          // removeClickListener()
        }
    }

    const removeClickListener = () => {
        document.removeEventListener('click', outsideClickListener)
    }

    document.addEventListener('click', outsideClickListener)
}

const isVisible = elem => !!elem && !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length ) // source (2018-03-11): https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js 

export {
    map, 
    lerp, 
    clamp,
    randomNumber,
    getMousePos,
    preloadImages,
    preloadFonts
};

